import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/index.less'
import {ADDRESS,vipapi,CONFIG} from '@/api/index.js'
import { Field,CellGroup } from 'vant';
import 'vant/lib/index.css';

Vue.use(Field);
Vue.use(CellGroup);
// 挂载api接口
Vue.prototype.$vipapi = vipapi
// 挂载环境地址
Vue.prototype.$ADDRESS = ADDRESS
// 挂载通用配置，token/设备号
Vue.prototype.$CONFIG = CONFIG

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')